import { render, staticRenderFns } from "./CommentLike.vue?vue&type=template&id=414b1b74&"
import script from "./CommentLike.vue?vue&type=script&lang=js&"
export * from "./CommentLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports